module.exports = __webpack_public_path__ + "img/liucheng.bd64c429.png";